module.exports = __webpack_public_path__ + "img/study_banner.f48c18a4.jpg";